import React from 'react';
import i18next from 'i18next';

import { translateContent } from '~src/services/translationServices';
import ListItem from '~src/shared/lists/listItem/ListItem';
import { AttributeI } from '~src/interfaces/attributes.types';
import { HoverContent, ListItemProps } from '~src/shared/lists/listItem/types';

interface Props {
  t: i18next.TFunction;
  attribute: AttributeI;
  link: string;
}

const MemoizedAttributesListItem: React.FC<Props> = React.memo(function AttributesListItem({ t, attribute: { name, internal_type, attribute_options = [] }, link }) {
    let listTypeKey = `x.attributes.list.types.${internal_type}`;
    if (internal_type === 'option') {
      listTypeKey += '.list';
    }
    const itemProps: ListItemProps<string> = [
      {
        key: listTypeKey,
        txt: t(listTypeKey, { count: attribute_options.length }),
      },
      {
        key: `x.attributes.list.types.${internal_type}`,
        txt: t(`x.attributes.list.types.${internal_type}`),
      },
    ];

    const hoverContent: HoverContent = {
      wideBtn: {
        key: 'x.attributes.list.details.item.edit_label',
        txt: t('x.attributes.list.details.item.edit_label'),
        icon: 'iconGear',
        link,
      },
    };

    return <ListItem title={translateContent(name)} itemProps={itemProps} hoverContent={hoverContent} />;
  },
);

export default MemoizedAttributesListItem;
